import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MEDIA } from "../../lib/constants";

const BRANDS = [
  {
    key: "khalifa-kush",
    tag: "Featured Flower",
    name: "Khalifa Kush",
    image: MEDIA.khalifaKush,
    blurb:
      "Wiz Khalifa's namesake genetics — potent OG Kush lineage, pine-forward terpenes, hand-finished for DC patients. In stock now at 4915 Georgia Ave NW.",
    to: "/blog/khalifa-kush-dc-dispensary",
    cta: "Read the strain guide",
  },
  {
    key: "alt-sol",
    tag: "Featured Brand",
    name: "Alt Sol Cannabis",
    image: MEDIA.altSolJars,
    blurb:
      "Hand-finished flower from one of DC's most trusted cultivators. Duct Tape, Blue Sharpies, Hashburger — small-batch jars, curated for the DWC menu.",
    to: "/blog/alt-sol-cannabis-dc",
    cta: "Meet the brand",
  },
];

export const FeaturedBrands = () => {
  return (
    <section
      className="bg-white py-24 sm:py-32"
      id="featured-brands"
      data-testid="featured-brands"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-14">
          <div className="md:col-span-8">
            <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-5">
              What We Carry
            </div>
            <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              Featured <em className="text-brand">brands</em> at DWC.
            </h2>
          </div>
          <div className="md:col-span-4">
            <p className="text-ink-muted leading-relaxed">
              Every jar on the DWC menu is sourced from DC-licensed cultivators
              and lab-tested. Here&rsquo;s a look at two of the brands DC
              patients ask for by name.
            </p>
          </div>
        </div>

        <div
          className="grid md:grid-cols-2 gap-6"
          data-testid="featured-brands-grid"
        >
          {BRANDS.map((b) => (
            <Link
              key={b.key}
              to={b.to}
              className="group block bg-white border border-black/10 hover:border-brand transition-colors overflow-hidden"
              data-testid={`featured-brand-${b.key}`}
            >
              <div className="aspect-[4/5] sm:aspect-[4/5] overflow-hidden bg-ink">
                <img
                  src={b.image}
                  alt={`${b.name} available at District Wellness Center — 4915 Georgia Ave NW, Washington DC`}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
                />
              </div>
              <div className="p-8 sm:p-10">
                <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-4">
                  {b.tag}
                </div>
                <h3 className="font-serif text-3xl sm:text-4xl leading-tight tracking-tight group-hover:text-brand transition-colors">
                  {b.name}
                </h3>
                <p className="mt-4 text-base text-ink-muted leading-relaxed">
                  {b.blurb}
                </p>
                <div className="mt-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-brand border-b border-brand/40 pb-1 group-hover:border-brand transition-colors">
                  {b.cta} <ArrowUpRight size={14} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedBrands;
